export const API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://apiracepickup.sucisoft.com/api/" //https://api.racepickup.com/api/
    : "http://localhost:3100/api/";
export const WEB_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://apiracepickup.sucisoft.com/"  //https://api.racepickup.com/
    : "http://localhost:3100/";
